import { CardActionArea } from "@mui/material";
import { Link } from "react-router-dom";

export interface IBybImageWrapper {
  href?: string;
  onImageClick?: () => void;
}

/**
 *
 * @param children
 * @param href
 * @param onImageClick
 * @returns a link or a card action area depending on the props
 *
 */
const BybImageWrapper = ({ children, href, onImageClick }: IBybImageWrapper & { children: React.ReactNode }) => {
  if (href) {
    return <Link to={href}>{children}</Link>;
  } else if (onImageClick) {
    return (
      <CardActionArea sx={{ height: "100%" }} onClick={onImageClick}>
        {children}
      </CardActionArea>
    );
  } else {
    return <>{children}</>;
  }
};

export default BybImageWrapper;
